var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    {
      staticClass: "stretch-grid has-search",
      attrs: { id: "order-page", color: "white" }
    },
    [
      _c(
        "q-collapsible",
        {
          staticClass: "search-box",
          attrs: { "collapse-icon": "fa fa-angle-down" }
        },
        [
          _c("template", { staticClass: "search-box", slot: "header" }, [
            _c(
              "h5",
              { staticStyle: { padding: "12px 0px 12px 13px", width: "100%" } },
              [
                _c("q-icon", {
                  staticStyle: { padding: "0 5px 3px" },
                  attrs: { name: "fa fa-search", color: "primary" }
                }),
                _vm._v("Orders Search\n      ")
              ],
              1
            )
          ]),
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c("div", { staticClass: "sl-row no-margin" }, [
                _c(
                  "div",
                  { staticClass: "sl-col-4" },
                  [
                    _c("q-input", {
                      attrs: { "float-label": "Order ID" },
                      model: {
                        value: _vm.searchFields.ORDER_ID,
                        callback: function($$v) {
                          _vm.$set(_vm.searchFields, "ORDER_ID", $$v)
                        },
                        expression: "searchFields.ORDER_ID"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "sl-col-4" },
                  [
                    _c(
                      "q-field",
                      [
                        _c("q-select", {
                          attrs: {
                            "float-label": "Order Type",
                            options: _vm.searchOrderTypeOptions
                          },
                          model: {
                            value: _vm.searchFields.LK_ORDER_TYPE_ID,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.searchFields,
                                "LK_ORDER_TYPE_ID",
                                $$v
                              )
                            },
                            expression: "searchFields.LK_ORDER_TYPE_ID"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "sl-col-4" },
                  [
                    _c("q-input", {
                      attrs: { "float-label": "Class ID" },
                      model: {
                        value: _vm.searchFields.CLASS_ID,
                        callback: function($$v) {
                          _vm.$set(_vm.searchFields, "CLASS_ID", $$v)
                        },
                        expression: "searchFields.CLASS_ID"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "sl-row no-margin" }, [
                _c(
                  "div",
                  { staticClass: "sl-col-4" },
                  [
                    _c("q-datetime", {
                      attrs: {
                        clearable: "",
                        before: [{ icon: "calendar_today" }],
                        type: "date",
                        format: "MM/DD/YYYY",
                        "float-label": "Order Start Date",
                        popover: ""
                      },
                      on: {
                        clear: function($event) {
                          _vm.search()
                        }
                      },
                      model: {
                        value: _vm.searchFields["ORDER_START_DATE"],
                        callback: function($$v) {
                          _vm.$set(_vm.searchFields, "ORDER_START_DATE", $$v)
                        },
                        expression: "searchFields['ORDER_START_DATE']"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "sl-col-4" },
                  [
                    _c("q-datetime", {
                      attrs: {
                        clearable: "",
                        before: [{ icon: "calendar_today" }],
                        type: "date",
                        format: "MM/DD/YYYY",
                        "float-label": "Order End Date",
                        popover: ""
                      },
                      on: {
                        clear: function($event) {
                          _vm.search()
                        }
                      },
                      model: {
                        value: _vm.searchFields["ORDER_END_DATE"],
                        callback: function($$v) {
                          _vm.$set(_vm.searchFields, "ORDER_END_DATE", $$v)
                        },
                        expression: "searchFields['ORDER_END_DATE']"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "sl-col-4" },
                  [
                    _c("div", { staticStyle: { height: "12px" } }),
                    _vm.$p(["ADMIN", "MANAGER"], "or")
                      ? _c("user-auto-complete", {
                          attrs: {
                            onSelect: _vm.selectUser,
                            userId: _vm.searchFields.USER_ID,
                            placeholder: "Search Users by Name, Email",
                            clearable: "",
                            clear: _vm.search,
                            helper: _vm.userHelper
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _c(
                "q-toolbar",
                {
                  staticStyle: { "padding-right": "60px" },
                  attrs: { color: "white" }
                },
                [
                  _c("q-toolbar-title"),
                  _c("q-btn", {
                    staticStyle: { "margin-right": "5px" },
                    attrs: {
                      color: "secondary",
                      label: "Clear",
                      outline: "",
                      size: "sm",
                      type: "reset"
                    },
                    on: { click: _vm.fetchAndClear }
                  }),
                  _c("q-btn", {
                    attrs: {
                      color: "primary",
                      label: "Search",
                      size: "sm",
                      type: "submit"
                    },
                    on: {
                      click: function($event) {
                        _vm.search()
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        2
      ),
      _c("Grid", {
        staticClass: "fit",
        attrs: {
          id: "ordersGrid",
          module: _vm.module,
          data: _vm.orderList,
          visibleColumns: _vm.visibleColumns,
          columns: _vm.columnOptions,
          pagination: _vm.pagination,
          onLaunch: _vm.one,
          onRequest: _vm.fetch,
          onExport: _vm.fetch,
          loading: _vm.loadingData,
          filterable: _vm.filterable
        },
        scopedSlots: _vm._u([
          {
            key: "col-item-notes",
            fn: function(props) {
              return [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "max-width": "250px",
                      overflow: "hidden",
                      "text-overflow": "ellipsis"
                    },
                    attrs: { title: props.value }
                  },
                  [_vm._v(_vm._s(props.value))]
                )
              ]
            }
          },
          {
            key: "col-item-status",
            fn: function(props) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "label",
                    class: {
                      blue: props.value == "Placed",
                      green:
                        props.value == "Completed" ||
                        props.value == "Fulfilled",
                      red: props.value == "Cancelled" || props.value == "Unpaid"
                    },
                    staticStyle: {
                      display: "inline-block",
                      "margin-left": "10px",
                      "border-radius": "30px"
                    }
                  },
                  [_vm._v(_vm._s(props.value || "?"))]
                )
              ]
            }
          },
          {
            key: "col-item-user",
            fn: function(props) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "label green round small",
                    staticStyle: {
                      "font-size": "11px",
                      padding: "6px 0px",
                      "margin-right": "5px"
                    }
                  },
                  [_vm._v(_vm._s(_vm.formatUserInitials(props.value)))]
                ),
                _vm._v(
                  "\n      " +
                    _vm._s(props.value.USER_FIRST_NAME) +
                    " " +
                    _vm._s(props.value.USER_LAST_NAME) +
                    "\n    "
                )
              ]
            }
          }
        ])
      }),
      _c("order-management-modal"),
      _c(
        "q-layout-footer",
        [
          _c(
            "q-toolbar",
            [
              _c("q-toolbar-title"),
              _vm.$p(["ADMIN"])
                ? _c("q-btn", {
                    staticClass: "q-mx-md",
                    attrs: {
                      label: "Order Types",
                      icon: "fa fa-gear",
                      color: "blue",
                      outline: ""
                    },
                    on: {
                      click: function($event) {
                        _vm.openOrderManagementModal()
                      }
                    }
                  })
                : _vm._e(),
              _c("q-btn", {
                attrs: {
                  label: "New Order",
                  icon: "fa fa-plus",
                  color: "primary"
                },
                on: {
                  click: function($event) {
                    _vm.paymentModalOpenState(true)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }